export enum MediaAssetType {
  Audio = 'Audio',
  Video = 'Video',
}
